import { Cloud, K8sProvider } from '@cast/shared-types';

export const k8sProviderToCloud: Record<K8sProvider, Cloud | undefined> = {
  [K8sProvider.AKS]: Cloud.azure,
  [K8sProvider.EKS]: Cloud.aws,
  [K8sProvider.GKE]: Cloud.gcp,
  [K8sProvider.KOPS]: undefined,
  [K8sProvider.ROSA]: undefined,
  [K8sProvider.ANYWHERE]: undefined,
  [K8sProvider.SELF_HOSTED]: undefined,
  [K8sProvider.OKE]: Cloud.oracle,
};

export const PROVIDER_NAME_MAP: Record<`${K8sProvider}`, string> = {
  [K8sProvider.EKS]: 'EKS',
  [K8sProvider.GKE]: 'GKE',
  [K8sProvider.AKS]: 'AKS',
  [K8sProvider.KOPS]: 'kOps',
  [K8sProvider.ROSA]: 'OpenShift',
  [K8sProvider.ANYWHERE]: 'Anywhere',
  [K8sProvider.SELF_HOSTED]: 'k8s on EC2',
  [K8sProvider.OKE]: 'OKE',
};

export const CSP_NAME_MAP: Record<Cloud, string> = {
  [Cloud.gcp]: 'GCP',
  [Cloud.aws]: 'AWS',
  [Cloud.azure]: 'Azure',
  [Cloud.oracle]: 'Oracle',
  [Cloud.nebius]: 'Nebius',
  [Cloud.unknown]: 'Unknown',
};
